import { render, staticRenderFns } from "./confirmaSenha.vue?vue&type=template&id=4c99a3d0&"
import script from "./confirmaSenha.vue?vue&type=script&lang=js&"
export * from "./confirmaSenha.vue?vue&type=script&lang=js&"
import style0 from "./confirmaSenha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports